'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 14h-2v-4H9V7h2v4h2V7h2v10z' });

var Looks4 = function Looks4(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

Looks4 = (0, _pure2.default)(Looks4);
Looks4.muiName = 'SvgIcon';

exports.default = Looks4;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/Looks4.js
// module id = 2593
// module chunks = 0